import { Checkbox } from '@zoopla-eng/zds-components/checkbox';
import { Stack } from '@zoopla-eng/zds-components/stack';

export type RentalTerm = '' | 'short';
export type BillsIncluded = '' | 'true';
export type PetsAllowed = '' | 'true';
export type IncludeRented = '' | 'true';
export type IncludeSharedAccommodation = '' | 'false';

type LettingType = {
    rentalTerm: RentalTerm;
    billsIncluded: BillsIncluded;
    petsAllowed: PetsAllowed;
    includeRented: IncludeRented;
    includeSharedAccommodation: IncludeSharedAccommodation;
};

type LettingTypeProps = {
    value: LettingType;
    onChange: (lettingType: LettingType) => void;
};

export const LettingType = ({ value, onChange }: LettingTypeProps) => {
    return (
        <Stack
            flexDirection="row"
            flexWrap="wrap"
            columnGap="0"
            rowGap="$S400"
            items={{
                width: '100%',
                '@M100': {
                    width: '50%'
                }
            }}
        >
            <Checkbox
                name="rental_term"
                label="Short lets"
                checked={value.rentalTerm === 'short'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        rentalTerm: checked ? 'short' : ''
                    });
                }}
            />
            <Checkbox
                name="bills_included"
                label="Bills included"
                checked={value.billsIncluded === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        billsIncluded: checked ? 'true' : ''
                    });
                }}
            />
            <Checkbox
                name="pets_allowed"
                label="Pets allowed"
                checked={value.petsAllowed === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        petsAllowed: checked ? 'true' : ''
                    });
                }}
            />
            <Checkbox
                name="include_shared_accommodation"
                label="Shared accommodation"
                checked={value.includeSharedAccommodation === ''}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        includeSharedAccommodation: checked ? '' : 'false'
                    });
                }}
            />
            <Checkbox
                name="include_rented"
                label="Include let or let agreed"
                checked={value.includeRented === 'true'}
                onCheckedChange={(checked) => {
                    onChange({
                        ...value,
                        includeRented: checked ? 'true' : ''
                    });
                }}
            />
        </Stack>
    );
};
